const AddToDb = (second) => {
  localStorage.setItem("break-time", JSON.stringify(second));
};

const getDataFromStorage = () => {
  let storeBreakTime = 0;
  let storedSecond = localStorage.getItem("break-time");
  if (storedSecond) {
    storeBreakTime = JSON.parse(storedSecond);
    console.log(typeof storeBreakTime);
  }
  return storeBreakTime;
};
export { AddToDb, getDataFromStorage };
